import React, { Component } from 'react'
import styled from 'styled-components'

import Logic from './logic'

import ResultTarifV2 from '../ResultTarifV2'
import ButtonOutlineV2 from '../ButtonOutlineV2'
import DetailsModalV2 from '../DetailsModalV2'
import JoinTariffModalV2 from '../JoinTariffModalV2'
import CompareModalV2 from '../CompareModalV2'
import SmallModalV2 from '../SmallModalV2'
import ButtonGradientV2 from '../ButtonGradientV2'

import IcAlert from './images/ic-alert.component.svg'

import { sendGevent } from 'utils'

@Logic
export default class ResultsSectionV2 extends Component {
  state = {
    detailsModal: false,
    joinModal: false,
    adhesionTariff: null,
  }

  setCompareItem = (id) => {
    const newList = [...this.props.compareList]

    if (newList.includes(id)) {
      const index = newList.indexOf(id)
      newList.splice(index, 1)
    } else {
      if (newList.length === 2) {
        return
      }
      newList.push(id)
    }

    this.actions.setCompareList(newList)
  }

  disableCompareModal = () => {
    return (
      this.props.compareList.length === 0 || this.props.compareList.length > 2
    )
  }

  /**
   * Opens/Closes Compare modal
   */
  toggleCompareModal = () => {
    this.actions.toggleCompareModal(!this.props.compareModal)
  }

  /**
   * Opens/Closes Details modal
   */
  toggleDetailsModal = (tariff) => {
    if (tariff) {
      sendGevent('simulador', 'Saber mais', 'Saber mais sobre um tarifário')
      tariff && this.actions.fetchTariffInfo(tariff)
    }
    const tariffPriceListTimeCycle = tariff && tariff.priceListTimeCycle
    this.setState({
      detailsModal: !this.state.detailsModal,
      adhesionTariff: tariff,
      priceListTimeCycle: tariffPriceListTimeCycle || null,
    })
  }

  /**
   * Opens/Closes join modal
   */
  toggleJoinModal = (tariff) => {
    if (tariff) {
      sendGevent('simulador', 'Aderir', 'Aderir a um tarifário')
      tariff && this.actions.fetchTariffInfo(tariff)
    } else {
      this.actions.setTariffInfo(null)
    }

    this.setState({
      adhesionTariff: tariff,
      joinModal: !this.state.joinModal,
    })
  }

  renderCompareModalModal() {
    const { compareModal, compareList } = this.props

    return compareModal ? (
      <CompareModalV2
        modalTriggerHeight={this.props.modalTriggerHeight}
        setModalTriggerHeight={this.props.setModalTriggerHeight}
        onClose={() => this.actions.toggleCompareModal(false)}
        compareList={compareList}
        simulation={this.props.simulation}
        onJoin={(tariff) => {
          this.toggleCompareModal()
          this.toggleJoinModal(tariff)
        }}
      />
    ) : null
  }

  renderJoinModal() {
    const { simulation, tariffInfo, translations } = this.props
    const { joinModal, adhesionTariff } = this.state

    if (
      joinModal &&
      adhesionTariff &&
      tariffInfo &&
      !tariffInfo.pricelistadditionalinfo.is_regulated
    ) {
      return (
        <JoinTariffModalV2
          {...this.props}
          tariff={adhesionTariff}
          tariffInfo={tariffInfo}
          changeTariff={this.toggleJoinModal}
          simulation={simulation}
          isHome={false}
          modalTriggerHeight={this.props.modalTriggerHeight}
          setModalTriggerHeight={this.props.setModalTriggerHeight}
        />
      )
    } else if (
      joinModal &&
      adhesionTariff &&
      tariffInfo &&
      tariffInfo.pricelistadditionalinfo.is_regulated
    ) {
      return (
        <SmallModalV2
          style={{ width: '500px', height: '450px' }}
          title='Aderir a um tarifário regulado?'
          icon={<IcAlert />}
          onClose={() => this.toggleJoinModal()}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              alignItems: 'center',
            }}>
            <Disclaimer>
              <DisclaimerTitle>Esclarecimentos</DisclaimerTitle>
              <DisclaimerText>
                De acordo com a legislação em vigor, os consumidores do mercado
                liberalizado que pretendam regressar ao mercado regulado devem
                contactar o comercializador de último recurso.
              </DisclaimerText>
              <DisclaimerTitle>
                {translations.ESCLARECIMENTO_CONTACTE}
              </DisclaimerTitle>
            </Disclaimer>
            <div
              style={{
                display: 'flex',
                placeItems: 'center',
                width: '50%',
                flex: 1,
              }}>
              <ButtonGradientV2
                onClick={() => {
                  this.setState({ joinModal: false })
                }}>
                Fechar
              </ButtonGradientV2>
            </div>
          </div>
        </SmallModalV2>
      )
    } else {
      return null
    }
  }

  renderDetailsModal() {
    const { detailsModal, adhesionTariff, priceListTimeCycle } = this.state
    const { loading } = this.props

    return detailsModal && adhesionTariff ? (
      <DetailsModalV2
        hasBtns
        modalTriggerHeight={this.props.modalTriggerHeight}
        setModalTriggerHeight={this.props.setModalTriggerHeight}
        tariff={adhesionTariff}
        tariffInfo={this.props.tariffInfo}
        priceListTimeCycle={priceListTimeCycle}
        onClose={() => {
          this.actions.resetTariffInfo()
          this.setState({ detailsModal: false, adhesionTariff: null })
        }}
        loading={loading}
        onJoin={(tariff) => {
          this.toggleDetailsModal(null)
          this.toggleJoinModal(tariff)
        }}
      />
    ) : null
  }

  /** Lonely boy */
  render() {
    const { results, bestAnnualBilling, count, ...restProps } = this.props

    return (
      <Wrapper {...restProps}>
        <TitleRow>
          <h3>Resultados ({count})</h3>
          <ButtonOutlineV2
            setModalTriggerHeight={this.props.setModalTriggerHeight}
            style={{ maxWidth: '180px' }}
            onClick={this.toggleCompareModal}
            disabled={this.disableCompareModal()}>
            Comparar Resultados
          </ButtonOutlineV2>
        </TitleRow>
        <ResultsWrapper>
          {results.map((result, index) => (
            <ResultTarifV2
              key={`result_tariff_card_${index}_${result.id}`}
              index={index}
              bestAnnualBilling={bestAnnualBilling}
              setCompare={this.setCompareItem}
              compareList={this.props.compareList}
              toggleJoinModal={this.toggleJoinModal}
              toggleDetailsModal={this.toggleDetailsModal}
              result={result}
              setModalTriggerHeight={this.props.setModalTriggerHeight}
            />
          ))}
        </ResultsWrapper>

        {this.renderJoinModal()}
        {this.renderDetailsModal()}
        {this.renderCompareModalModal()}
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
`

const TitleRow = styled.div`
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 0px;

  h3 {
    flex: 1 0 0;
    color: #1d1e22;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 1px;
    margin: 0;
    text-transform: unset;
    text-align: left;
  }
`

const ResultsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding-bottom: 24px;
`

const Disclaimer = styled.div`
  padding: 20px 0;
`

const DisclaimerTitle = styled.span`
  display: block;
  font-weight: bold;
  margin-bottom: 10px;
  color: #93c13e;
  font-size: 16px;
`

const DisclaimerText = styled.div`
  margin-bottom: 10px;
  font-size: 14px;

  ${({ red }) =>
    red &&
    `
  color: indianred;
  `}
`



// WEBPACK FOOTER //
// ./src/components/ResultsSectionV2/index.js